import { setLoadingState, addMessage } from './MessageActions/';

export const rx =
  (fnRx, ...args) =>
  async dispatch => {
    try {
      dispatch(addMessage({ error: '', success: '' }));
      dispatch(setLoadingState(true));
      const result = await fnRx(dispatch, ...args);
      dispatch(setLoadingState(false));
      const message = {
        error: result?.data?.message || '',
        success: result?.data?.data || '',
      };
      dispatch(addMessage(message));
    } catch (err) {
      dispatch(addMessage({ error: err.message, success: '' }));
    }
  };
